import {
  FETCH_ADVANCED_CRITERIA_SUCCESS,
  FETCH_ENHANCED_SEARCH_RESULTS_PAGE,
  FETCH_ENHANCED_SEARCH_RESULTS_PAGE_FAILURE,
  FETCH_ENHANCED_SEARCH_RESULTS_PAGE_SUCCESS,
  MAKE_ENHANCED_SEARCH_ADVANCED,
  RESET_SEARCH_RESULTS,
} from '../actions/SearchPageActions';

const enhancedInitialState = {
  isAdvancedSearch: false,
  searching: false,
  entityNames: [],
  sortExpression: '',
  searchText: '',
  searchOption: 0,
  currentPageIndex: 0,
  pageSize: 25,
  getCrossReferences: false,
  advancedSearchCriteria: [],
  rows: [],
  totalResultCount: 0,
  loading: false,
  error: false,
  hasMoreResults: false,
  page: 0,
  totalPages: 0,
  useContainsTable: false,
  hasError: false,
};

const searchPageReducer = (state = enhancedInitialState, action) => {
  switch (action.type) {
    case RESET_SEARCH_RESULTS:
      return {
        ...state,
        rows: [],
        totalResultCount: 0,
        currentPageIndex: 0,
        hasMoreResults: false,
        page: 0,
        totalPages: 0,
        error: false,
        useContainsTable: false,
      };
    case FETCH_ENHANCED_SEARCH_RESULTS_PAGE:
      return {
        ...state,
        ...action.payload,
        loading: true,
        error: false,
        searching: true,
      };
    case FETCH_ENHANCED_SEARCH_RESULTS_PAGE_SUCCESS: {
      const { rows, totalResultCount, page, totalPages, searchText } = action.payload;
      const moreRows =
        page === 0 && totalResultCount === 0
          ? [...(state?.rows || [])]
          : [...(state?.rows || []), ...rows];
      const newTotalResultCount = page === 0 ? totalResultCount : state?.totalResultCount;
      return {
        ...state,
        loading: false,
        searching: false,
        totalPages,
        page,
        totalResultCount: newTotalResultCount,
        rows: moreRows,
        searchText,
      };
    }
    case FETCH_ENHANCED_SEARCH_RESULTS_PAGE_FAILURE: {
      return {
        ...state,
        loading: false,
        searching: false,
        error: true,
      };
    }
    case FETCH_ADVANCED_CRITERIA_SUCCESS: {
      return {
        ...state,
        advancedSearchCriteria: action.payload,
      };
    }
    case MAKE_ENHANCED_SEARCH_ADVANCED: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};

export default searchPageReducer;
